@if (sessionService.client(); as cl) {
  <div
    class="client-label"
    [class.selectable]="clientSelectable()"
    [class.animated-label]="cl.name.length > 18"
    (click)="selectClient()">
    <div>
      {{ cl.name }}
    </div>
  </div>
}
@if (sessionService.labelOption | async; as lbl) {
  <div
    class="label"
    [class.selectable]="lbl.selectable"
    [class.animated-label]="lbl.name.length > 22"
    (click)="selectLabel(lbl)">
    <div>
      {{ lbl.name }}
      @if (lbl.selectable) {
        <svg-icon icon="icon_arrow_down"></svg-icon>
      }
    </div>
  </div>
}
